import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, LOCALES } from "./translations";

const I18nContext = createContext(null);

function detectInitialLocale() {
  if (typeof window === "undefined") return "cs";
  const saved = window.localStorage.getItem("tv_locale");
  if (saved && LOCALES.includes(saved)) return saved;
  const browser = (navigator.language || "cs").slice(0, 2).toLowerCase();
  if (LOCALES.includes(browser)) return browser;
  return "cs";
}

export function I18nProvider({ children }) {
  const [locale, setLocale] = useState(detectInitialLocale);

  useEffect(() => {
    window.localStorage.setItem("tv_locale", locale);
    document.documentElement.setAttribute("lang", locale);
  }, [locale]);

  const value = useMemo(() => {
    const dict = translations[locale] || translations.cs;
    return { locale, setLocale, t: dict, locales: LOCALES };
  }, [locale]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
